'use strict';

var UserPreferencesConfig = function UserPreferencesConfig(userPreferencesService) {
  userPreferencesService.extendMomentConstants();
};
UserPreferencesConfig.$inject = ['UserPreferencesService'];
module.exports = UserPreferencesConfig;